import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container block" }
const _hoisted_2 = { class: "topfilter" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "flexcenter" }
const _hoisted_5 = { class: "table" }
const _hoisted_6 = { class: "table-value" }
const _hoisted_7 = { class: "value-item" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "flexend" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_date_picker, {
          onChange: _ctx.changeFilterDate,
          modelValue: _ctx.filterDate,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterDate) = $event)),
          type: "daterange",
          "unlink-panels": "",
          "range-separator": "至",
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期",
          shortcuts: _ctx.shortcuts,
          format: "YYYY/MM/DD",
          "value-format": "YYYY-MM-DD"
        }, null, 8, ["onChange", "modelValue", "shortcuts"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          style: {"marrgin-left":"10px !important"},
          type: "primary",
          onClick: _ctx.onShowpopup
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode("导出")
          ])),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, "保费总额：¥" + _toDisplayString(_ctx.totalValue2), 1)
      ]),
      _createVNode(_component_el_table, {
        data: _ctx.tableData,
        style: {"width":"100%"},
        "header-row-style": { color: '#202536' },
        "row-style": { color: '#5E617D' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            align: "center",
            label: "交易单号",
            "min-width": "180",
            prop: "flowNum"
          }),
          _createVNode(_component_el_table_column, {
            label: "类型",
            align: "center",
            prop: "paymentStatus"
          }, {
            default: _withCtx((scope) => [
              (scope.row.paymentStatus == 0 )
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, " 支付"))
                : _createCommentVNode("", true),
              (scope.row.paymentStatus == 1 )
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, "退款 "))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            label: "账期",
            "min-width": "130",
            prop: "insureDay"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            label: "支付时间",
            "min-width": "140",
            prop: "createTime"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            label: "保险商品",
            "min-width": "160",
            prop: "insureCompanyPlanName"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            label: "在保人次",
            prop: "totalPersons"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            label: "空投总额",
            "min-width": "120",
            prop: "virtualStaffFee"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            label: "保费总额",
            "min-width": "120",
            prop: "totalInsuranceFee"
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(_component_el_pagination, {
        class: "pagination",
        currentPage: _ctx.pageNum,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pageNum) = $event)),
        "page-size": _ctx.pageSize,
        "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pageSize) = $event)),
        "page-sizes": [10, 30, 50, 100],
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total,
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.getBongBillRecord
      }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isUp,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isUp) = $event)),
      width: "450px",
      title: "账单导出",
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_button, {
            type: "",
            onClick: _ctx.onCancel
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.onSure
          }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode("导出")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_form, {
            model: _ctx.form,
            ref: "ruleFormRef",
            "label-width": "85px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "账单类型:",
                prop: "type",
                onChange: _ctx.onTypeChange,
                style: {"margin-bottom":"0px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.form.type,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.type) = $event)),
                    class: "ml-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, {
                        label: "1",
                        size: "large"
                      }, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createTextVNode("人员账单")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, {
                        label: "2",
                        size: "large"
                      }, {
                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createTextVNode("账单明细")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["onChange"]),
              _createVNode(_component_el_form_item, { label: "保险商品" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.ensurePlanId,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.ensurePlanId) = $event)),
                    placeholder: "请选择保险商品",
                    clearable: "",
                    style: {"width":"250px"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ensurePlanList, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.code,
                          label: item.planName,
                          value: item.insureEnsurePlanId
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "账单日期" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.form.filterDate,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.filterDate) = $event)),
                    type: "month",
                    style: {"width":"250px"},
                    placeholder: "请选择月份",
                    format: "YYYY/MM",
                    size: "small",
                    clearable: false,
                    "value-format": "YYYY-MM"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}